import { Fragment, useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import classes from "./TableBody.module.css";
import { toast } from "react-toastify";
import { Skeleton } from "@mui/material";
import PromptModal from "../../UI/PromptModal/PromptModal";
import MultiLanTxt from "../../UI/MultiLanTxt/MultiLanTxt";
import { useNavigate } from "react-router-dom";
import ngStrExtracter from "../../../utils/extractors/ngStrExtracter";
import cellphoneCompiler from "../../../utils/textUtils/cellphoneCompiler";
import TableRow from "../TableRow/TableRow";

let targetedDataForDelete = null;
let targetedDataEventForDelete = null;
const TableBody = ({
  datas,
  view,
  editablelity,
  selectable,
  setSelectedRows,
  selectedRows,
  density,
  isLoading,
  dataLimit,
  actionHandler,
  addEditRowComponent: AddEditRowContainer,
  currentPage,
  sendReqPerChange,
  searchVal,
  sortIconName,
  canEdit,
  canInsertEdition,
  canInsertEditionAddress,
  canDelete,
  forceLtr,
  actionStatus,
  setActionStatus,
  tableInfos,
  setTableInfos,
  clonedTableInfos,
  rowClickable,
  isProcessual,
  searchTypes,
  setCurrentPage,
  userLanguage,
  canViewForm,
  customChangeSelectedRowsHandler,
  customChecked,
}) => {
  const [editedData, setEditedData] = useState({});
  const [hideSelectedData, setHideSelectedData] = useState({});
  const [mountModal, setMountModal] = useState(false);
  const navigate = useNavigate();
  const editButtonHandler = (da) => {
    if (editablelity) {
      if (actionStatus === "adding") {
        toast.warn("لطفا ابتدا ردیف افزودن اطلاعات را ببندید");
      } else {
        setTableInfos(clonedTableInfos);
        setActionStatus("editing");
        setHideSelectedData((prevState) => ({
          ...!prevState,
          [da.id]: !prevState[da.id],
        }));
        setEditedData(da);
      }
    } else {
      actionHandler(da, "edit");
    }
  };
  const viewButtonHandler = (da) => {
    if (editablelity) {
      if (actionStatus === "adding") {
        toast.warn("لطفا ابتدا ردیف افزودن اطلاعات را ببندید");
      } else {
        setTableInfos(clonedTableInfos);
        setActionStatus("editing");
        setHideSelectedData((prevState) => ({
          ...!prevState,
          [da.id]: !prevState[da.id],
        }));
        setEditedData(da);
      }
    } else {
      actionHandler(da, "view");
    }
  };
  const requestDeleteHandler = (e, dad) => {
    e.stopPropagation();
    targetedDataForDelete = dad;
    targetedDataEventForDelete = e;
    setMountModal(true);
  };

  const insertEditionButtonHandler = (da) => {
    if (editablelity) {
      if (actionStatus === "adding") {
        toast.warn("لطفا ابتدا ردیف افزودن اطلاعات را ببندید");
      } else {
        setTableInfos(clonedTableInfos);
        setActionStatus("editing");
        setHideSelectedData((prevState) => ({
          ...!prevState,
          [da.id]: !prevState[da.id],
        }));
        setEditedData(da);
      }
    } else {
      navigate(`${canInsertEditionAddress}${da.id}`);
    }
  };

  const renderCells = (dataRecord) => {
    let orderedTableInfos = tableInfos.sort((a, b) => a.order - b.order);
    return orderedTableInfos.map((each, index) => {
      let fieldIsNested = each.field.includes(".");

      let finalStr;
      if (fieldIsNested) {
        // let fieldsArray = each.field.split(".");
        // finalStr = dataRecord;
        // const tempArr = [];
        // const strArr = [];
        // for (const fiel of fieldsArray) {
        //   if (tempArr.length === 0) {
        //     if (Array.isArray(finalStr[fiel])) {
        //       for (const each of finalStr[fiel]) {
        //         tempArr.push(each);
        //       }
        //     } else {
        //       if (finalStr !== null && finalStr[fiel] !== null) {
        //         finalStr = finalStr[fiel];
        //       } else {
        //         finalStr = "";
        //       }
        //     }
        //   } else {
        //     for (const eachObj of tempArr) {
        //       strArr.push(eachObj[fiel]);
        //     }
        //     finalStr = strArr.join(",");
        //   }
        // }
        finalStr = ngStrExtracter(dataRecord, each.field);
      } else {
        finalStr =
          typeof dataRecord[each.field] === "object"
            ? dataRecord[each.field]
                ?.map((each) =>
                  each?.name ? each?.name : each?.title ? each?.title : "which key should be shown",
                )
                .join(" , ")
            : dataRecord[each.field];
      }

      if (each?.type) {
        if (each?.type === "boolean") {
          if (typeof finalStr === "string" && finalStr.includes(",")) {
            finalStr = finalStr
              .split(",")
              .map((value) => (value === "true" ? each.options[0].name : each.options[1].name));
            // .join(",");
          } else {
            finalStr =
              finalStr === true || finalStr === "true" ? each.options[0].name : each.options[1].name;
          }
        } else if (each?.type === "mobileNumber") {
          finalStr = cellphoneCompiler(finalStr, "noPrefix");
        }
      }

      return (
        <Fragment key={index * 54821327}>
          {each.show ? (
            each?.type && each?.type === "icon" ? (
              <td className={[classes.tdData, forceLtr ? classes.ltrDir : null].join(" ")}>
                <span
                  className={[
                    classes.downloadIconContainer,
                    typeof finalStr === "string" ? classes.pointerCursor : null,
                  ].join(" ")}
                  onClick={() => (each.clickHandler ? each.clickHandler(dataRecord) : null)}
                >
                  {typeof finalStr === "string" ? each.icon : "فایل یافت نشد"}
                </span>
              </td>
            ) : (
              <td
                className={[
                  classes.tdData,
                  forceLtr ? classes.ltrDir : null,
                  each.field === "code" ? classes.codeTd : null,
                  /^is[A-Z]/.test(each.field) ? classes.statusTd : null,
                ].join(" ")}
              >
                <span
                  className={each?.forcePe ? classes.forcePe : null}
                  style={isLoading ? { visibility: "hidden", opacity: "0" } : {}}
                  title={finalStr}
                >
                  {each?.shouldBeTranslated ? (
                    <MultiLanTxt tid={finalStr} />
                  ) : finalStr === undefined ? (
                    "-"
                  ) : (
                    finalStr
                  )}
                </span>
              </td>
            )
          ) : null}
        </Fragment>
      );
    });
  };
  // const changeSelectedRowsHandler = (da) => { let copiedSelectedRows = [...selectedRows]; let res = copiedSelectedRows?.map((each) => each.id).includes(da.id); if (res) { let filteredRows = copiedSelectedRows.filter((row) => row.id !== da.id); setSelectedRows(filteredRows); } else { setSelectedRows((prevState) => [...prevState, da]); } };

  const changeSelectedRowsHandler = (da) => {
    if (customChangeSelectedRowsHandler) {
      customChangeSelectedRowsHandler(da);
    } else {
      setSelectedRows((ps) => {
        const clickedIndex = ps.findIndex((row) => row.id === da.id);
        if (clickedIndex !== -1) {
          return ps.toSpliced(clickedIndex, 1);
        } else {
          return [...ps, da];
        }
      });
    }
  };
  const rowClickHandler = (dad) => {
    if (rowClickable) {
      actionHandler(dad, "navigate");
    }
  };
  const deleteClickHandler = async (e, dad) => {
    e.stopPropagation();
    const wasSuccessfull = await actionHandler(dad, "delete");
    if (wasSuccessfull) {
      let fetchAttributes = {
        searchTypes,
        search: { ...searchVal },
        sort: { ...sortIconName },
        page: 1,
        dataLimit,
        shouldFetchTotalNumber: true,
      };
      setCurrentPage(1);
      sendReqPerChange(fetchAttributes);
    }
    setMountModal(false);
  };
  return (
    <>
      <PromptModal
        forceLtr={forceLtr}
        confirmHandler={() => deleteClickHandler(targetedDataEventForDelete, targetedDataForDelete)}
        isMounted={mountModal}
        setIsMounted={setMountModal}
      />
      {/* FOR EDITABLE LISTS WHICH WE CAN INSERT IN THE COMPONENT   */}
      {editablelity ? (
        <AddEditRowContainer
          editedData={editedData}
          setHideSelectedData={setHideSelectedData}
          setEditedData={setEditedData}
          selectable={selectable}
          sendReqPerChange={sendReqPerChange}
          dataLimit={dataLimit}
          currentPage={currentPage}
          sortIconName={sortIconName}
          searchVal={searchVal}
          actionStatus={actionStatus}
          setActionStatus={setActionStatus}
          tableInfos={tableInfos}
          setTableInfos={setTableInfos}
          clonedTableInfos={clonedTableInfos}
          searchTypes={searchTypes}
        />
      ) : null}
      {
        // isLoading ? (
        //   [...Array(dataLimit)].map((e, i) => (
        //     <tr
        //       className={[
        //         classes.skeletonTr,
        //         density === "normal"
        //           ? classes.normalHeight
        //           : density === "compact"
        //           ? classes.compactHeight
        //           : density === "large"
        //           ? classes.largeHeight
        //           : null,
        //       ].join(" ")}
        //       key={i}
        //     >
        //       <td colSpan="100%">
        //         <Skeleton animation="wave" className={classes.skeletonRow} />
        //       </td>
        //       {/* <td /> */}
        //     </tr>
        //   ))
        // ) :
        datas?.length > 0 ? (
          datas.map((dad, index) => (
            <TableRow
              key={index}
              dad={dad}
              index={index}
              isProcessual={isProcessual}
              hideSelectedData={hideSelectedData}
              rowClickable={rowClickable}
              density={density}
              selectedRows={selectedRows}
              selectable={selectable}
              customChecked={customChecked}
              currentPage={currentPage}
              dataLimit={dataLimit}
              renderCells={renderCells}
              view={view}
              canDelete={canDelete}
              canEdit={canEdit}
              canViewForm={canViewForm}
              canInsertEdition={canInsertEdition}
              forceLtr={forceLtr}
              userLanguage={userLanguage}
              isLoading={isLoading}
              rowClickHandler={rowClickHandler}
              changeSelectedRowsHandler={changeSelectedRowsHandler}
              viewButtonHandler={viewButtonHandler}
              editButtonHandler={editButtonHandler}
              insertEditionButtonHandler={insertEditionButtonHandler}
              onRequestDelete={requestDeleteHandler}
            />
          ))
        ) : (
          <tr className={classes.emptyTr}>
            <td className={classes.emptyTd} colSpan="100%">
              {forceLtr ? "There is no record in database" : <MultiLanTxt tid="NO_RECORD_IN_DATABASE" />}
            </td>
          </tr>
        )
      }
    </>
  );
};

export default TableBody;
